export const ERROR_TYPE = {
  GEO: 'geo',
  LICENSE: 'license',
  UNIVERSAL: 'universal',
  BROWSER: 'browser',
  ID_ABSENT: 'idAbsent',
  OPEN_IN_APP: 'openInApp',
  DRM: 'drm',
  DEVICE: 'device',
};
